import { useParams } from "react-router-dom";
import All from "./all";
import Mobile from "./mobile";
import Game from "./game";
import Marketing from "./admin-dashboard";
import { useState } from "react";
import {
  Container,
  ProjectShowCase,
  ViewAllButton,
} from "../styles/projectTab";
import AdminDashboard from "./admin-dashboard";
import { StyledArrow } from "./arrow";
import { useLocation } from "react-router-dom";

const Projects = () => {
  const [currentTabs, setCurrentTabs] = useState("All");
  const { id } = useParams();
  function handleClick(e) {
    setCurrentTabs(e.target.name);
  }
  const location = useLocation();
  const isProjectLocation = location.pathname === "/project";
  const projects = [
    {
      name: "All",
      content: <All />,
    },
    {
      name: "Web application",
      content: <Game />,
    },
    {
      name: "Mobile application",
      content: <Mobile />,
    },
    {
      name: "Admin-dashboar",
      content: <AdminDashboard />,
    },
  ];
  return (
    <Container>
      <div className="tab">
        {projects.map((tab, i) => (
          <button
            className="buttons"
            key={i}
            name={tab.name}
            disabled={currentTabs === `${tab.name}`}
            onClick={handleClick}
          >
            {tab.name}
          </button>
        ))}
      </div>
      <div
        className="teacher-content"
        style={{
          width: "100%",
        }}
      >
        {projects.map((tab, i) => (
          <ProjectShowCase key={i}>
            {currentTabs === `${tab.name}` && tab.content}
          </ProjectShowCase>
        ))}
      </div>
      {!isProjectLocation && (
        <ViewAllButton to="/project">
          <p>VIEW ALL PROJECTS</p>
          <div>
            <StyledArrow />
          </div>
        </ViewAllButton>
      )}
    </Container>
  );
};

export default Projects;
